import React, { useEffect, useMemo, useRef, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title, Filler } from "chart.js";
import { appConfig } from "../../../utils/app.config";
import axios from "axios";
import { getCustomKbAPI } from "./utils/constants";
import { useKBState } from "./customHooks/useKBState";
interface KnowledgeAuditDashboardProps {
    color: any
}

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title, Filler)

interface KbSummary {
    totalArticles: number;
    approvalStage: number;
    pendingReview: number;
    draft: number;
    published: number;
    retired: number;
    flagged: number;
    lowUsage: number;
    lowFeedback: number;
    duplicates: number;
    audited: number;
    pendingAudit: number;
    AI_Readability_Score: string;
    AI_Structuring_Score: string;
    AI_Search_Optimization_Score: string;
    AI_KB_Quality_Score: string;
    aiAgentReady?: number;

}

const generateChartData = (color: string, kbsummary: KbSummary | null, customKbData: Number, summaryDataDetails: any[]) => {
    const isDark = color === "dark";

    return {
        labels: ["Duplicates", "Published", "CustomKB "],
        datasets: [
            {
                data: [
                    // kbsummary?.published || 0,
                    // kbsummary?.pendingAudit || 0,
                    // kbsummary?.duplicates|| 0,
                    summaryDataDetails?.[0]?.duplicates?.count || 0,
                    summaryDataDetails?.[0]?.publishedArticle?.count || 0,
                    customKbData || 0

                ],
                backgroundColor: [ "#6EC8D7", "#A7D6E8",  "#5A9BD6"]
                ,
                hoverBackgroundColor: ["#6EC0D7", "#c0cdd2",  "#4E8CC4"],
                borderWidth: 0,
            },
        ],
    };
};

const KnowledgeAuditDashboard: React.FC<KnowledgeAuditDashboardProps> = ({ color }) => {



    const [barChartData, setBarChartData] = useState(null);
    const [kbSummary, setKbSummary] = useState<KbSummary | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const apiUrl = appConfig.apiUrl + '/v2.0/litebot/admin/charts';
    const kbSummaryApiUrl = appConfig.baseUrl + "/gwt/api/v2.0/litebot/admin/session/kb-summary";
    const [popup, setPopup] = useState({
        openTranscript: false,
        popupHeader: "",
        popupType: ""
    })
    const [tableData, setTableData] = useState<any[]>([])

    const [kbtableData, setKbTableData] = useState<any[]>([])

    const [value, setValue] = useState({
        openTranscript: false,
        transcript: ""
    })
    const [popupTitle, setPopupTitle] = useState(" ");
    const [isFetching, setIsFetching] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);

    const [summaryDataDetails, setSummaryDataDetails] = useState<any[]>([])


    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch JWT token from session storage
                // const token = sessionStorage.getItem("cva.jwt.access.token");
                // if (!token) throw new Error("User is not authenticated.");
                console.log("inside kad useeffect")
                // Add token to headers
                const config = {
                    headers: {
                        // Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                };

                // Fetch both APIs in parallel
                 
                const kbSummaryResponse = await axios.get(
                                kbSummaryApiUrl,
                                config
                            );

                console.log("FULL RESPONSE:", kbSummaryResponse);
                console.log("DATA:", kbSummaryResponse?.data?.data);
                // Save results in state
                // setBarChartData(chartResponse.data.barChartData);
                setKbSummary(kbSummaryResponse.data?.data);
                await getCustomKb();

                const summaryDataDetails1 = await summaryData();
                setSummaryDataDetails(summaryDataDetails1)
                console.log("SummaryDataDetails", summaryDataDetails);

                // Example: store it in state if you want to display it

            } catch (error: any) {
                console.error("Error fetching data:", error);
            }
            finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [kbSummaryApiUrl]);

    console.log("kbSummaryResponse", kbSummary)


    const getCustomKb = async () => {

        try {
            const formData = new FormData();
            formData.append("actions", "getCustomKb");
            formData.append("method", "POST");
            formData.append("action", "fetch");

            const options = {
                method: "POST",
                // headers: {
                //     "Content-Type": "application/json",
                // },
                // body: JSON.stringify({
                //     "action": "fetch",
                // }),
                body: formData
            };

            const result = await (await fetch(`${getCustomKbAPI}`, options)).json();
            console.log("get custom kb result", result);


            SetcustomKbData(result.length)
            setKbTableData(result)

            setIsFetching(false)



        } catch (error) {
            console.error("Error fetching KB:", error);
        }
        // finally {
        //     setLoading(false);
        // }
    };

    // const getCustomKbFull = async () => {

    //     try {
    //         const formData = new FormData();
    //         formData.append("actions", "getCustomKb");
    //         formData.append("method", "POST");
    //         formData.append("action", "fetch");

    //         const options = {
    //             method: "POST",
    //             // headers: {
    //             //     "Content-Type": "application/json",
    //             // },
    //             // body: JSON.stringify({
    //             //     "action": "fetch",
    //             // }),
    //             body:formData
    //         };

    //         const result = await (await fetch(`${getCustomKbAPI}`, options)).json();
    //         console.log("get custom kb result", result);

    //         setKbTableData(result)

    //         setIsFetching(false)


    //     } catch (error) {
    //         console.error("Error fetching KB:", error);
    //     }
    //     // finally {
    //     //     setLoading(false);
    //     // }
    // };


    const [customKbData, SetcustomKbData] = useState<number>(0);

    // useEffect(() => {
    //     const loadData = async () => {
    //         setLoading(true);

    //         try {
    //             await getCustomKb();   // your function
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     loadData();
    // }, []);


    // const [kbSummaryResponse, setKbSummaryResponse] = useState([]);

    const getSummaryDataApi = appConfig.baseUrl + "/gwt/api/v2.0/litebot/admin/session/getSummaryData"


    const summaryData = async () => {
        try {
            const response = await fetch(getSummaryDataApi, {
                method: "GET",
            });

            const result = await response.json();

            console.log("summaryData Details:", result);

            return result; // return full summary object

        } catch (error) {
            console.error("Error while fetching KB Summary:", error);
            return null;
        }
    };





    // useEffect(() => {
    //     if (!popup.openTranscript) return;

    //     if (popup.popupType === "CustomKB") getCustomKbFull();

    // }, [popup.openTranscript]);


    useEffect(() => {
        if (!popup.openTranscript) return;

        // const auditedGroup = ["pendingAudit", "audited", "flagged"];
        // if (!auditedGroup.includes(popup.popupType)) return;

        const loadData = async () => {
            setTableLoading(true);



            const summaryDetails = summaryDataDetails[0]

            console.log("summary Data :::: ", summaryDetails)

            // console.log("popup type before switch:", popup.popupType);
            // console.log("summary.pendingAudit.items:", summaryDataDetails?.pendingAudit?.items);

            if (!summaryDetails) {
                console.log("Summary is NULL");
                setTableLoading(false);
                setTableData([]);
                return;
            }

            let data: any[] = []

            switch (popup.popupType) {
                case "pendingAudit":
                    // console.log("INSIDE SWITCH â†’ pendingAudit");
                    // console.log("DATA TO SET:", summaryDataDetails.pendingAudit.items);
                    data = summaryDetails.pendingAudit?.items || [];
                    break;

                case "audited":
                    data = summaryDetails.audited?.items || [];
                    break;

                case "publishedArticle":
                    data = summaryDetails.publishedArticle?.items || [];
                    break;

                case "flagged":
                    data = summaryDetails.flagged?.items || [];
                    break;

                case "approvalStage":
                    data = summaryDetails.approvalStage?.items || [];
                    break;

                case "pendingReview":
                    data = summaryDetails.pendingReview?.items || [];
                    break;

                case "draft":
                    data = summaryDetails.draft?.items || [];
                    break;

                case "retired":
                    data = summaryDetails.retired?.items || [];
                    break;

                case "duplicates":
                    data = summaryDetails.duplicates?.items || [];
                    break;

                case "lowFeedback":
                    data = summaryDetails.lowFeedback?.items || [];
                    break;

                case "lowUsage":
                    data = summaryDetails.lowUsage?.items || [];
                    break;

                default:
                    data = [];
            }
            setTableData(data)
            console.log("tableData1", tableData);
            setTableLoading(false)
        };

        loadData();
    }, [popup.openTranscript, popup.popupType]);







    const pieChartData = useMemo(
        () => generateChartData(color, kbSummary, customKbData, summaryDataDetails),
        [color, kbSummary, customKbData, summaryDataDetails]
    );

    const gaugeOptions = {
        cutout: "50%",
        rotation: 0,
        AspectRatio: 1,
        plugins: {
            tooltip: {
                enabled: true,
            },
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
    };
    const lineChartData = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        datasets: [

            {
                label: "undefined",
                data: [2, 3, 4, 3, 5, 4, 5, 6, 7, 1, 2, 5],
                borderColor: 'red',
                backgroundColor: "red",
                pointBackgroundColor: "red",
                pointRadius: 1,
                pointHoverRadius: 2,
                fill: true,
                tension: 0.0,
            },
        ],
    };

    const lineOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 10;

    const activeTableData =
        popup.popupType === "CustomKB"
            ? kbtableData
            : tableData;

    const normalizedSearch = search.toLowerCase();

    const filteredData = (activeTableData || []).filter((item) => {
        return Object.values(item || {}).some((value) =>
            value?.toString().toLowerCase().includes(normalizedSearch)
        );
    });

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [search, popup.popupType]);

    useEffect(() => {
        if (!popup.openTranscript) {
            setSearch("")
        }
    }, [popup.openTranscript]);

    const tableScrollRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        if (tableScrollRef.current) {
            tableScrollRef.current.scrollTop = 0;
        }
    }, [currentPage]);

    console.log("publishedarticle count::", summaryDataDetails?.[0]?.publishedArticle?.count)
    console.log("pendingaudit count::", summaryDataDetails?.[0]?.pendingAudit?.count)
    console.log("duplicates::", summaryDataDetails?.[0]?.duplicates?.count)
    return (
        <>
            {loading ? (
                <div
                    style={{
                        height: "70vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div
                        style={{
                            fontSize: "18px",
                            height: "18px",
                            width: "18px",
                            marginRight: "8px",
                        }}
                        className="spinner-border"
                        role="status"
                    ></div>
                </div>
            ) : (
                <div data-bs-theme={color} className="p-2 h-100 ka-dashboard-main-div">
                    <div className="row g-0">
                        <div className="col-md-4 col-lg-4 col-xl-3 ka-cards">
                            <div
                                style={{
                                    position: "relative",
                                    overflow: "hidden",
                                    minHeight: "500px",
                                    padding: "26px 22px 22px",
                                    borderRadius: "18px",
                                    color: "#ffffff",
                                    background:
                                        "radial-gradient(circle at 88% 12%, rgba(255,255,255,.13), transparent 24%), radial-gradient(circle at 12% 92%, rgba(255,255,255,.08), transparent 30%), linear-gradient(145deg, #3e0975 0%, #62388e 55%, #896bab 100%)",
                                    boxShadow: "0 16px 35px rgba(62, 9, 117, .28)",
                                }}
                            >
                                {/* Decorative background */}
                                <div
                                    style={{
                                        position: "absolute",
                                        width: "230px",
                                        height: "230px",
                                        right: "-115px",
                                        top: "130px",
                                        borderRadius: "50%",
                                        background: "rgba(216,204,226,.10)",
                                        pointerEvents: "none",
                                    }}
                                />

                                {/* Article icon */}
                                <div
                                    style={{
                                        position: "relative",
                                        width: "50px",
                                        height: "50px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "14px",
                                        background: "rgba(216,204,226,.18)",
                                        border: "1px solid rgba(216,204,226,.32)",
                                        fontSize: "22px",
                                        marginBottom: "18px",
                                    }}
                                >
                                    <i className="bi bi-file-earmark-text-fill"></i>
                                </div>

                                {/* Total articles */}
                                <div style={{ position: "relative" }}>
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: 600,
                                            opacity: 0.9,
                                            marginBottom: "2px",
                                        }}
                                    >
                                        Total Articles
                                    </div>
                                    <div
                                        style={{
                                            fontSize: "58px",
                                            lineHeight: 1,
                                            fontWeight: 800,
                                            letterSpacing: "-2px",
                                        }}
                                    >
                                        {kbSummary?.totalArticles || 0}
                                    </div>
                                    <div
                                        style={{
                                            marginTop: "7px",
                                            fontSize: "11px",
                                            opacity: 0.78,
                                        }}
                                    >
                                        Total knowledge base articles
                                    </div>
                                </div>

                                {/* Published articles */}
                                <div
                                    style={{
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "12px",
                                        marginTop: "18px",
                                        padding: "13px 14px",
                                        borderTop: "1px solid rgba(216,204,226,.42)",
                                        borderBottom: "1px solid rgba(216,204,226,.24)",
                                    }}
                                >
                                    <i
                                        className="bi bi-book"
                                        style={{ fontSize: "25px", opacity: 0.92 }}
                                    ></i>
                                    <div>
                                        <div
                                            style={{
                                                fontSize: "30px",
                                                lineHeight: 1,
                                                fontWeight: 800,
                                            }}
                                        >
                                            {kbSummary?.published || 0}
                                        </div>
                                        <div
                                            style={{
                                                marginTop: "5px",
                                                fontSize: "10px",
                                                lineHeight: 1.25,
                                                opacity: 0.88,
                                            }}
                                        >
                                            Total Published Articles in ServiceNow
                                        </div>
                                    </div>
                                </div>

                                {/* AI scores */}
                                <div
                                    style={{
                                        position: "relative",
                                        display: "grid",
                                        gap: "8px",
                                        marginTop: "17px",
                                    }}
                                >
                                    {[
                                        {
                                            label: "AI Readability Score",
                                            value: kbSummary?.AI_Readability_Score || "0%",
                                            icon: "bi-book",
                                            iconBg: "#51d6c1",
                                        },
                                        {
                                            label: "AI Structuring Score",
                                            value: kbSummary?.AI_Structuring_Score || "0%",
                                            icon: "bi-layers",
                                            iconBg: "#6db7ff",
                                        },
                                        {
                                            label: "AI Search Optimization Score",
                                            value: kbSummary?.AI_Search_Optimization_Score || "0%",
                                            icon: "bi-search",
                                            iconBg: "#fede7b",
                                        },
                                        {
                                            label: "AI KB Quality Score",
                                            value: kbSummary?.AI_KB_Quality_Score || "0%",
                                            icon: "bi-star-fill",
                                            iconBg: "#f1977f",
                                        },
                                    ].map((score) => {
                                        const numericScore = Number(String(score.value).replace("%", "")) || 0;
                                        return (
                                            <div
                                                key={score.label}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "9px",
                                                    padding: "8px 9px",
                                                    borderRadius: "10px",
                                                    background: "rgba(255,255,255,.96)",
                                                    color: "#18203b",
                                                    border: "1px solid rgba(255,255,255,.35)",
                                                    boxShadow: "0 4px 10px rgba(25,18,92,.10)",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        width: "28px",
                                                        height: "28px",
                                                        minWidth: "28px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "8px",
                                                        background: score.iconBg,
                                                        color: "#fff",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    <i className={`bi ${score.icon}`}></i>
                                                </span>
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            gap: "6px",
                                                            fontSize: "10px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            {score.label}
                                                        </span>
                                                        <strong style={{ fontSize: "11px" }}>{score.value}</strong>
                                                    </div>
                                                    <div
                                                        style={{
                                                            height: "4px",
                                                            marginTop: "5px",
                                                            overflow: "hidden",
                                                            borderRadius: "999px",
                                                            background: "#dfe3ee",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                display: "block",
                                                                width: `${Math.max(0, Math.min(100, numericScore))}%`,
                                                                height: "100%",
                                                                borderRadius: "999px",
                                                                background: score.iconBg,
                                                            }}
                                                        ></span>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-8 col-lg-8 col-xl-6 ka-cards">
                            <p className="m-0 ka-title">Overview of KB Health</p>
                            <div
                                className="overview-grid"
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "280px 1fr",
                                    gap: "16px",
                                    justifyItems: "center",
                                    alignItems: "center",
                                    border: "1px solid var(--bs-dark-border-subtle)",
                                    borderRadius: "10px",
                                    padding: "20px",
                                }}
                            >
                                <style>
                                    {`
                                       @media (max-width: 991px) {
                                        .overview-grid {
                                         grid-template-columns: 1fr !important;
                                         }
                                        }
                                       @media (max-width: 576px) {
                                        .overview-grid {
                                        grid-template-columns: 1fr !important;
                                         }
                                        }
                                    `}
                                </style>
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{
                                        height: "220px",
                                        width: "220px",
                                        margin: "0 auto",
                                        }}
                                >
                                    <Doughnut data={pieChartData} options={gaugeOptions} />
                                </div>

                                <div

                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, 1fr)",
                                        gap: "12px",
                                        }}
                                    > 
                                  {/* Articles Published */}
                                <div
                                    className="overview-grid-item d-flex flex-column justify-content-center align-items-center text-center"
                                    style={{
                                        minHeight: "110px",
                                        border: "1px solid var(--bs-primary-border-subtle)",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        borderLeft: "4px solid #198754",
                                    }}
                                    onClick={() =>
                                        setPopup({
                                            openTranscript: true,
                                            popupHeader: "Articles Published",
                                            popupType: "publishedArticle"
                                        })
                                    }
                                >
                                    <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.publishedArticle?.count || 0}</p>
                                    <p className="m-0 fw-light">Knowledge Audit Published Articles</p>
                                </div>

                                {/* Articles Pending Action */}
                                {/* <div
                                    className="overview-grid-item d-flex flex-column justify-content-center align-items-center text-center"
                                    style={{
                                        height: "110px",
                                        width: "160px",
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                    }}
                                    onClick={() =>
                                        setPopup({
                                            openTranscript: true,
                                            popupHeader: "Articles Pending Action",
                                            popupType: "pendingAudit"
                                        })
                                    }

                                >
                                    <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.pendingAudit?.count || 0}</p>
                                    <p className="m-0 fw-light">Articles Pending Action</p>
                                </div> */}

                                {/* Total CKA Count */}
                                <div
                                    className="overview-grid-item d-flex flex-column justify-content-center align-items-center text-center"
                                   style={{
                                        minHeight: "110px",
                                        border: "1px solid var(--bs-primary-border-subtle)",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        borderLeft: "4px solid #198754",
                                    }}
                                    onClick={() =>
                                        setPopup({
                                            openTranscript: true,
                                            popupHeader: "Custom KB Articles",
                                            popupType: "CustomKB"
                                        })

                                    }
                                >
                                    <p className="m-0 fw-bold">{customKbData}</p>
                                    <p className="m-0 fw-light">Custom KB Articles</p>
                                </div>

                                {/* AI Agent-ready Articles */}
                                <div
                                    className="overview-grid-item d-flex flex-column justify-content-center align-items-center text-center"
                                 style={{
                                    minHeight: "110px",
                                    border: "1px solid var(--bs-primary-border-subtle)",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    borderLeft: "4px solid #0d6efd",
                                }}
                                    onClick={() =>
                                        setPopup({
                                            openTranscript: true,
                                            popupHeader: "AI Agent-ready Articles",
                                            popupType: "audited"
                                        })
                                    }
                                >
                                    <p className="m-0 fw-bold">{summaryDataDetails[0]?.audited?.count || 0}</p>
                                    <p className="m-0 fw-light">AI Agent-ready Articles</p>
                                </div>

                                {/* Articles Flagged */}
                                <div
                                    className="overview-grid-item d-flex flex-column justify-content-center align-items-center text-center"
                                    style={{
                                        minHeight: "110px",
                                        border: "1px solid var(--bs-primary-border-subtle)",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        borderLeft: "4px solid #dc3545",
                                    }}
                                    onClick={() =>
                                        setPopup({
                                            openTranscript: true,
                                            popupHeader: "Articles Flagged",
                                            popupType: "flagged"
                                        })
                                    }
                                >
                                    <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.flagged?.count || 0}</p>
                                    <p className="m-0 fw-light">Articles Flagged</p>
                                </div>
                            </div>

                            </div>

                            <p className="m-0 ka-title">Need Intervention</p>
                            <div className={`d-flex mt-2 h-100 justify-content-center align-items-center flex-column`}>
                                <div className="intervention d-flex">
                                    {/* <div className="col-4">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Articles in Approval Stage",
                                                    popupType: "approvalStage"
                                                })
                                            }
                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.approvalStage?.count || 0}</p>
                                            <p className="m-0 fw-light">Articles in Approval Stage</p>
                                        </div>

                                    </div> */}
                                    <div className="col-6">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Articles Pending for Review",
                                                    popupType: "pendingReview"
                                                })
                                            }
                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.pendingReview?.count || 0}</p>
                                            <p className="m-0 fw-light">Articles Pending for Review</p>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Articles in Draft State",
                                                    popupType: "draft"
                                                })
                                            }
                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.draft?.count || 0}</p>
                                            <p className="m-0 fw-light">Articles in Draft State.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12 col-xl-3 ka-cards">
                            <p className="m-0 ka-title text-center">Action Required</p>
                            <div className={`d-flex mt-2 h-100 justify-content-center align-items-center flex-column`}>
                                <div className="intervention row g-0">
                                    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-12">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Articles in Low Usage",
                                                    popupType: "lowUsage"
                                                })
                                            }
                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.lowUsage?.count || 0}</p>
                                            <p className="m-0 fw-light">Articles in Low Usage</p>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-12">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Articles with Low feedback",
                                                    popupType: "lowFeedback"
                                                })
                                            }

                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.lowFeedback?.count || 0}</p>
                                            <p className="m-0 fw-light">Articles with Low feedback</p>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-12">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Duplicate Articles",
                                                    popupType: "duplicates"
                                                })
                                            }
                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.duplicates?.count || 0}</p>
                                            <p className="m-0 fw-light">Duplicate Articles</p>
                                        </div>
                                    </div>
                                    <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-12">
                                        <div
                                            onClick={() =>
                                                setPopup({
                                                    openTranscript: true,
                                                    popupHeader: "Articles in Retire State",
                                                    popupType: "retired"
                                                })
                                            }
                                        >
                                            <p className="m-0 fw-bold">{summaryDataDetails?.[0]?.retired?.count || 0}</p>
                                            <p className="m-0 fw-light">Articles in Retire State</p>
                                        </div>
                                    </div>
                                </div>
                            </div></div>
                    </div>
                    {/* <div className="row g-0">
                <div className="col-12 col-xl-6 ka-cards">
                    <div className="h-100 ka-bar-chart">
                        {lineChartData && <Line data={lineChartData} options={lineOptions} />}

                    </div>
                </div>
                <div className="col-12 col-xl-6 ka-cards">
                    <div className="h-100 ka-bar-chart">
                        {lineChartData && <Line data={lineChartData} options={lineOptions} />}

                    </div>
                </div>
            </div> */}

                </div>)}

            {popup.openTranscript && (
                <div
                    className="modal fade show d-block"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
                        <div className="modal-content">

                            {/* HEADER */}
                            <div className="modal-header">
                                <h5 className="modal-title">{popup.popupHeader}</h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    style={{ color: "black", opacity: 1 }}
                                    onClick={() => setPopup({ openTranscript: false, popupType: "", popupHeader: "" })}
                                ></button>
                            </div>
                            <div className="g-search-wrapper" style={{ marginTop: "10px ", padding: "4px", border: "black" }}>
                                <i className="bi bi-search g-search-icon"></i>
                                <input
                                    type="search"
                                    className="g-search-input"
                                    placeholder="Search Articles..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                            </div>

                            {/* BODY */}
                            <div className="modal-body p-0"
                                ref={tableScrollRef}
                                style={{ overflowY: "auto" }}>


                                {popup.popupType === "CustomKB" ? (


                                    <table className="table table-striped table-hover learning-table" style={{ marginBottom: 0, marginTop: 0 }}>
                                        <thead className={color === "dark" ? "table-light" : "table-dark"}>
                                            <tr>
                                                <th style={{ textAlign: "center" }}>Custom KA Number</th>
                                                <th style={{ textAlign: "center" }}>Description</th>
                                                <th style={{ textAlign: "center" }}>Date Created</th>

                                            </tr>
                                        </thead>

                                        <tbody>

                                            {isFetching ? (
                                                <tr>
                                                    <td colSpan={3} className="text-center">
                                                        Loading...
                                                    </td>
                                                </tr>

                                            ) : paginatedData.length === 0 ? (
                                                <tr>
                                                    <td colSpan={3} className="text-center">
                                                        No data to display
                                                    </td>
                                                </tr>

                                            ) : (
                                                paginatedData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td style={{ textAlign: "center" }}>{item.number || "No Data"}</td>
                                                        <td>{item.content || "No Data"}</td>
                                                        <td style={{ textAlign: "center" }}>{item.updated_date || "No Data"}</td>
                                                    </tr>
                                                ))
                                            )}

                                        </tbody>
                                    </table>

                                ) : (
                                    <table
                                        className="table table-striped table-hover learning-table"
                                        style={{ marginBottom: 0, marginTop: 0 }}
                                    >
                                        <thead className={color === "dark" ? "table-light" : "table-dark"}>
                                            <tr>

                                                <th className="sticky-header" style={{ textAlign: "center" }}>Article ID</th>
                                                <th className="sticky-header" style={{ textAlign: "center" }}>Short Description</th>
                                                <th className="sticky-header" style={{ textAlign: "center" }}>AI Article Entity</th>
                                                <th className="sticky-header" style={{ textAlign: "center" }}>Category</th>
                                                <th className="sticky-header" style={{ textAlign: "center" }}>Sub Category</th>
                                                <th className="sticky-header" style={{ textAlign: "center" }}>KB Article Content</th>

                                            </tr>

                                        </thead>

                                        <tbody>

                                            {tableLoading ? (
                                                <tr>
                                                    <td colSpan={6} className="text-center">
                                                        Loading...
                                                    </td>
                                                </tr>

                                            ) : paginatedData.length === 0 ? (
                                                <tr>
                                                    <td colSpan={6} className="text-center">
                                                        No data to display
                                                    </td>
                                                </tr>

                                            ) : (
                                                paginatedData.map((item, index) =>
                                                (
                                                    <tr key={index}>
                                                        <td style={{ textAlign: "center" }}>{item.Article_ID || "No Data"}</td>
                                                        <td style={{ textAlign: "center" }}> {item.Article_Title || "No Data"}</td>
                                                        <td style={{ textAlign: "center" }}>{item.AI_Article_Entity || "No Data"}</td>
                                                        <td style={{ textAlign: "center" }}>{item.Category || "No Data"}</td>
                                                        <td style={{ textAlign: "center" }}>{item.Subcategory || "No Data"}</td>
                                                        <td style={{ padding: "10px", textAlign: "center", }}>
                                                            <i
                                                                className="bi bi-eye-fill"
                                                                style={{ cursor: "pointer", fontSize: '20px' }}
                                                                onClick={() => {
                                                                    const cleanText =( item["KB_Article_Content_Html"] || '').replace(/src="\/sys_attachment\.do/g,'src="https://warwickdev.service-now.com/sys_attachment.do');
                                                                    // const cleanText = "sample Data"
                                                                    setPopupTitle("KB Article Content");
                                                                    setValue({
                                                                        ...value,
                                                                        openTranscript: true,
                                                                        transcript: cleanText,
                                                                    })
                                                                }

                                                                }
                                                            ></i>
                                                        </td>

                                                    </tr>
                                                ))
                                            )}

                                        </tbody>
                                    </table>
                                )}

                            </div>

                            {/* FOOTER */}
                            <div
                                className="modal-footer"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    margin: 0,
                                    padding: "12px 16px" // optional, clean spacing
                                }}
                            >
                                {/* LEFT: Showing info + Pagination */}
                                <div
                                    className="d-flex align-items-center gap-4"
                                    style={{ display: "flex", alignItems: "center", gap: "16px" }}
                                >
                                    {/* Showing rows info */}
                                    <div
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "38px", // matches pagination height
                                            whiteSpace: "nowrap"
                                        }}
                                    >
                                        Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                                        {(currentPage - 1) * itemsPerPage + paginatedData.length} of{" "}
                                        {filteredData.length} rows
                                    </div>

                                    {/* Pagination */}
                                    <nav>
                                        <ul
                                            className="pagination mb-0 d-flex align-items-center"
                                            style={{ display: "flex", alignItems: "center", margin: 0 }}
                                        >
                                            {/* Prev */}
                                            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    style={{ fontSize: "14px", height: "38px" }}
                                                    onClick={() => setCurrentPage((p) => p - 1)}
                                                >
                                                    Prev
                                                </button>
                                            </li>

                                            {/* Page info */}
                                            <li className="page-item disabled">
                                                <span
                                                    className="page-link"
                                                    style={{
                                                        height: "38px",
                                                        fontSize: "14px",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    Page {currentPage} of {totalPages}
                                                </span>
                                            </li>

                                            {/* Next */}
                                            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                                <button
                                                    className="page-link"
                                                    style={{ fontSize: "14px", height: "38px" }}
                                                    onClick={() => setCurrentPage((p) => p + 1)}
                                                >
                                                    Next
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>


                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    style={{
                                        width: "fit-content",
                                        height: "38px",          // matches pagination height
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px"
                                    }}
                                    onClick={() =>

                                        setPopup({
                                            openTranscript: false,
                                            popupType: "",
                                            popupHeader: ""
                                        })
                                    }
                                >
                                    <i className="bi bi-x-circle"></i> Close
                                </button>
                            </div>


                        </div>
                    </div>
                </div>
            )}

            {value.openTranscript && (
                <div
                    className="modal fade show d-block"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    tabIndex={-1}
                >
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                    style={{
                        width: "60vw",
                        maxWidth: "1400px",
                        }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {popupTitle}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    style={{ color: "black", opacity: 1 }}
                                    onClick={() => setValue({ ...value, openTranscript: false })}

                                ></button>
                            </div>
                            <div
                                className="modal-body"
                                style={{
                                    margin: 0,
                                    color: "black",
                                    maxHeight: "75vh",
                                    overflowY: "auto",
                                    padding: "16px",
                                    }}
                            >
                                {value.transcript ? (
                                    <div
                                    className="kb-content"
                                        style={{ fontSize: "14px" }}
                                        dangerouslySetInnerHTML={{
                                            __html: value.transcript,
                                        }}
                                        />
                                ) : (
                                    <div>No data available</div>
                                )}
                            </div>
                            <div
                                className="modal-footer"
                                style={{ justifyContent: "flex-end" }}
                            >
                                <button
                                    type="button"
                                    style={{
                                        width: "fit-content",
                                        lineHeight: "normal",
                                        height: "fit-content",
                                        display: "flex",
                                        gap: "8px",
                                    }}
                                    className="btn btn-secondary"
                                    onClick={() => setValue({ ...value, openTranscript: false })}
                                >
                                    <i className="bi bi-x-circle"></i>
                                    Close
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default KnowledgeAuditDashboard;